export default __webpack_public_path__ + "static/media/team-mario.13447492.png";